import { useSelector } from "react-redux";
import { PRODUCT_NOT_FOUND } from "../utils/Constants";
import { useEffect, useState } from "react";
import ProductCard from "./ProductCard";
import { useProductFetch } from "../hooks/useProductFetch";
import { useCategoryFetch } from "../hooks/useCategoryFetch";
import { useSubAndChildCategoryFetch } from "../hooks/useSubAndChildCategoryFetch";
import { useNavigate } from "react-router-dom";

function CategoryProduct({ categorySlug, subCategorySlug, childCategorySlug }) {
  const { subAndChildCategories } = useSelector((state) => state.category);
  const { productList } = useSelector((state) => state.product);
  const { storeCity } = useSelector((state) => state.auth);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const navigate = useNavigate();

  const { isLoading, hasMore } = useProductFetch(
    categorySlug,
    subCategorySlug,
    childCategorySlug,
    storeCity
  );
  useCategoryFetch();
  useSubAndChildCategoryFetch(categorySlug);

  const categoryName = categorySlug.replace(/-/g, " ");

  const handleCategoryPageNavigate = () => {
    navigate(`/category/${categorySlug}`);
  };

  const handleSubCatPageNavigate = (subUrl) => {
    navigate(`/category/${categorySlug}/${subUrl}`);
  };

  const handleChildCatPageNavigate = (subUrl, childUrl) => {
    navigate(`/category/${categorySlug}/${subUrl}/${childUrl}`);
  };

  useEffect(() => {
    if (!isLoading) {
      setInitialLoadComplete(true);
    }
  }, [isLoading]);

  return (
    <section className="shop py-20">
      <div className="container container-lg">
        <div className="row">
          {/* Sidebar Column - Always visible */}
          <div className="col-lg-2">
            <div className="shop-sidebar">
              <button
                type="button"
                className="shop-sidebar__close d-lg-none d-flex w-32 h-32 flex-center border border-gray-100 rounded-circle hover-bg-main-600 position-absolute inset-inline-end-0 me-10 mt-8 hover-text-white hover-border-main-600">
                <i className="ph ph-x"></i>
              </button>
              {subAndChildCategories?.length > 0 && (
                <div className="shop-sidebar__box border border-gray-100 rounded-8 p-10 mb-10">
                  <h6
                    onClick={() => handleCategoryPageNavigate()}
                    className="text-xl border-bottom border-gray-100 pb-10 mb-10"
                    style={{ textTransform: "capitalize", cursor: "pointer" }}>
                    {categoryName}
                  </h6>
                  <ul className="max-h-540 overflow-y-auto scroll-sm">
                    {subAndChildCategories &&
                      subAndChildCategories.map((sub, index) => (
                        <li className="mb-10" key={index}>
                          <button
                            className="text-gray-900 hover-text-main-600"
                            style={{ textAlign: "left" }}
                            onClick={() =>
                              handleSubCatPageNavigate(sub.slug_url)
                            }>
                            {sub.name}
                          </button>

                          <ul className="pl-3 mt-1">
                            {sub.childCategory &&
                              sub.childCategory.map((child, index) => (
                                <li
                                  className="text-gray-900 hover-text-main-600 cursor-pointer"
                                  style={{ textAlign: "left", marginLeft: 10 }}
                                  key={index}
                                  onClick={() =>
                                    handleChildCatPageNavigate(
                                      sub.slug_url,
                                      child.slug_url
                                    )
                                  }>
                                  - {child.name}
                                </li>
                              ))}
                          </ul>
                        </li>
                      ))}
                  </ul>
                </div>
              )}
            </div>
          </div>

          {/* Main Content Column */}
          <div className="col-lg-10">
            {isLoading && productList.length === 0 ? (
              <div className="flex justify-content-center text-center">
                <i
                  className="fa fa-spinner fa-spin fa-4x"
                  style={{ color: "#299e60" }}
                />
              </div>
            ) : productList.length > 0 ? (
              <>
                <ProductCard productList={productList} />

                {isLoading && (
                  <div className="flex justify-content-center text-center mt-3">
                    <i
                      className="fa fa-spinner fa-spin fa-2x"
                      style={{ color: "#299e60" }}
                    />
                  </div>
                )}

                {!isLoading && !hasMore && productList.length >= 10 && (
                  <div className="text-center mt-3">
                    <p>You've reached the end</p>
                  </div>
                )}
              </>
            ) : initialLoadComplete ? (
              <div className="text-center py-5">
                <img
                  src={PRODUCT_NOT_FOUND}
                  alt="Product Not Found"
                  className="img-fluid"
                  style={{ maxHeight: "300px", borderRadius: "50%" }}
                />
                <h5 className="mt-3 text-muted">No products found</h5>
                <p>Try adjusting your search or filters</p>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
}

export default CategoryProduct;
